import { render, staticRenderFns } from "./People.vue?vue&type=template&id=a7d23ea4&scoped=true&"
import script from "./People.vue?vue&type=script&lang=ts&"
export * from "./People.vue?vue&type=script&lang=ts&"
import style0 from "./People.vue?vue&type=style&index=0&id=a7d23ea4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d23ea4",
  null
  
)

export default component.exports